import React, { Component } from 'react';
import { Admin, Resource, fetchUtils  } from 'react-admin';

import dashboard from './documents/dashboard.js';
 
import { DocumentTypeList, DocumentTypeEdit, DocumentTypeCreate } from './documents/document_types.js';
import { ClientTypeList, ClientTypeEdit, ClientTypeCreate } from './documents/client_types.js';
import { ClientList, ClientCreate, ClientEdit  } from './documents/clients.js';
import { DocumentList, DocumentCreate, DocumentEditAdmin, DocumentEdit, DocumentListClients } from './documents/documents.js';
import { UserList, UserCreate, UserEdit, UserEditAdmin } from './documents/users.js';

import FolderIcon from '@material-ui/icons/Folder';
import { FolderList,  FolderCreate, FolderEdit, FolderListAdmin } from './documents/folders'

import StateIcon from '@material-ui/icons/Flag';
import CountryIcon from '@material-ui/icons/Flag';
import DocumentTypeIcon from '@material-ui/icons/ViewCarousel';
import ClientTypeIcon from '@material-ui/icons/Group';
import ClientIcon from '@material-ui/icons/Person';
import DocumentIcon from '@material-ui/icons/Archive';
import UserIcon from '@material-ui/icons/GroupAdd';

import simpleRestProvider from 'ra-data-simple-rest';
import addUploadFeature from './utils/addUploadFeature';
import authProvider from './utils/authProvider';
import configuration from './utils/config.js';

import MyLayout from './utils/MyLayout';
import MyLogin from './utils/MyLoginPage';

import { mergeTranslations } from 'react-admin';
import { reducer as tree } from 'ra-tree-ui-materialui';
import englishMessages from 'ra-language-english';
import treeEnglishMessages from 'ra-tree-language-english';

import NotFound from './NotFound';
import MyMenu from './utils/MyMenu';


const messages = {
    'en': mergeTranslations(englishMessages, treeEnglishMessages),
};

const i18nProvider = locale => messages[locale];
 

const httpClient = (url, options = {}) => {
    if (!options.headers) {
        options.headers = new Headers({ Accept: 'application/json' });
    }
    const token = localStorage.getItem('token');
    options.headers.set('Authorization', `Bearer ${token}`);
    return fetchUtils.fetchJson(url, options);
}

//const dataProvider = simpleRestProvider('http://127.0.0.1:8000/api');
const dataProvider = simpleRestProvider(configuration.api, httpClient );
const uploadCapableDataProvider = addUploadFeature(dataProvider);

class App extends Component {
 

    componentWillMount() {
      //  this.restoreFetch = fakeRestServer();
      //localStorage.removeItem('dbloades');
    //  console.log("wm");
    }

    componentWillUnmount() {
        //this.restoreFetch();
      //  console.log("wum");
    }

    render() {
               return (

                <Admin 
                    menu={MyMenu}
                    catchAll={NotFound}

                    title="FSI"
                    dashboard={dashboard}  
                    dataProvider={uploadCapableDataProvider} 
                    authProvider={authProvider}
                    appLayout={MyLayout}
                    loginPage={MyLogin}

                    i18nProvider={i18nProvider}
                    locale="en"
                    customReducers={{ tree }}
    >
       {permissions => [
             <Resource name="dashboard"   options={{ label: 'Dashboard'  }}  />,
              <Resource name="pending"   />,
              <Resource name="folders2"   />,
              <Resource name="avatars"  edit={UserEdit}  />,

              <Resource name="countries"  icon={CountryIcon} />,
              <Resource name="states"  icon={StateIcon}   />,

              <Resource name="document_types" 
                icon={DocumentTypeIcon} 
                list={permissions === 'admin' ? DocumentTypeList : null} 
                edit={permissions === 'admin' ? DocumentTypeEdit : null} 
                create={permissions === 'admin' ? DocumentTypeCreate : null} />,

              <Resource name="users"  
                icon={UserIcon} 
                list={permissions === 'admin' ? UserList : null} 
                create={permissions === 'admin' ? UserCreate : null} 
                edit={UserEditAdmin} />,

               <Resource name="client_types" 
                icon={ClientTypeIcon} 
                list={permissions === 'admin' ? ClientTypeList : null} 
                edit={permissions === 'admin' ? ClientTypeEdit : null} 
                create={permissions === 'admin' ? ClientTypeCreate : null} />,

              <Resource name="clients"   
                icon={ClientIcon} 
                list={permissions === 'admin' ? ClientList : null} 
                create={permissions === 'admin' ? ClientCreate : null} 
                edit={permissions === 'admin' ? ClientEdit : null} />,
              
              <Resource name="folders" 
                icon={FolderIcon} 
                list={(permissions === 'client') ? FolderList :      FolderListAdmin   } 
                create={(permissions === 'admin') ? FolderCreate : null } 
                edit={(permissions === 'admin') ? FolderEdit : null } />,

              <Resource name="documents" 
                list={permissions === 'admin' ? DocumentList : DocumentListClients} 
                icon={DocumentIcon}  
                edit={permissions === 'client' ? DocumentEdit : DocumentEditAdmin}  />,

              <Resource name="files" 
                create={(permissions === 'admin') ? DocumentCreate : DocumentCreate } 
                />,

              <Resource name="approvals"  edit={DocumentEditAdmin}  />,


        ]}
    </Admin>
 );
    }
}

 
export default App;  